exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".apponintment-add-left{width:30%}.apponintment-add-center,.apponintment-add-left{text-align:center;font-size:15px;font-weight:700;float:left}.apponintment-add-center{width:50px;margin-left:10px}.apponintment-add-right{width:calc(69% - 70px);margin-left:10px;text-align:center;font-size:15px;font-weight:700;float:right}.apponintment-add-query{width:100%;height:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/follow/followUpAppointment/add.vue
// module id = Krum
// module chunks = 0